import { render } from "./wfm-tabs-horizontal.vue?vue&type=template&id=5eaf4132&scoped=true"
import script from "./wfm-tabs-horizontal.vue?vue&type=script&lang=js"
export * from "./wfm-tabs-horizontal.vue?vue&type=script&lang=js"

import "./wfm-tabs-horizontal.vue?vue&type=style&index=0&id=5eaf4132&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eaf4132"]])

export default __exports__